import { Component, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { MdSnackBar } from '@angular/material';

import { TdLoadingService, TdDialogService, TdMediaService } from '@covalent/core';

import { RestService, StorageService } from '../../services';

import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { GasComponent } from '../gas.component';

@Component({
  selector: 'gasarticles',
  providers: [RestService, StorageService],
  templateUrl: './gasarticles.component.html',
  styleUrls: ['./gasarticles.component.scss']
})
export class GasArticlesComponent {

  private articles: any[];
  private stateMap = new Map();
  private returnArticles = new Set();
  private tracking: string;
  private hasReturned: Boolean = false;
  @Input("orderBusinessKey") public orderBusinessKey: string;
  @Input("projectId") public projectId: number;
  @Input("clearedStatus") public clearedStatus: string;
  @Input("mogid") public mogid: string;
  @Input("relatedArticleList") public relatedArticleList: any[];
  @Input("relatedOrderList") public relatedOrderList: any[];
  @Input("parcelCode") public parcelCode: string;
  @Input("activeOtherArticles") public activeOtherArticles: boolean;
  @Input("scannedSaveValue") public scannedSaveValue: string;
  @Output("onSave") onSave = new EventEmitter<any>();
  @Output("onCancel") onCancel = new EventEmitter<any>();

  constructor(
    private _loadingService: TdLoadingService,
    private _dialogService: TdDialogService,
    private _restService: RestService,
    private _storageService: StorageService,
    public media: TdMediaService,
    public _gasComponent: GasComponent) {
  }

  ngOnChanges(changes: any) {
    if (this.orderBusinessKey != null && this.projectId != null) {
      this.load();
    }
  }

  confirm() {
    //initialize orders to einlagern
    let orderReadyMap = new Map();
    let orderTrackingList = []; // orderList = [{"tracking": tracking, "order": {...}},{"tracking": tracking, "order": {...}}]
    orderReadyMap.set('ready', orderTrackingList);

    if (this.returnArticles.size > 0) {

      let orderArticleMap = new Map();
      // group articles per order to send one event per order
      for (let article of this.relatedArticleList) {
        if (this.returnArticles.has(article.businessKey)) {
          let orderArticleList = orderArticleMap.get(article.orderBusinessKey);
          if (!orderArticleList) {
            orderArticleList = []; 
          }
          orderArticleList.push(article);
          orderArticleMap.set(article.orderBusinessKey, orderArticleList);
        }  
      }


      // mog event erstellen (mark selected articles for return)
      let mogEvent = {
        mogid: this.mogid,
        eventType: 'RETURN',
        returnItems: []
        }
        let returnTrackingNumber = {
          code: this.parcelCode
        }
      
      for (let article of this.articles) {
        if (this.returnArticles.has(article.businessKey)) {
          let returnItem = {
            reference: article.articleReference,
            quantity: article.numberOfItems,
            returnTrackingNumbers: []
          }
          returnItem.returnTrackingNumbers.push(returnTrackingNumber);
          mogEvent.returnItems.push(returnItem);
        }
      }
      if (mogEvent.returnItems.length > 0) { // if we have really created an event
        // here add order to orderReadyMap (in orderTrackingList)
        orderTrackingList = orderReadyMap.get('ready');
        let order = {
          businessKey: this.orderBusinessKey,
          projectId: this.projectId
        }
        let tracking = this.parcelCode;
        let orderTrackingItem = {
          tracking: tracking,
          order: order
        }
        orderTrackingList.push(orderTrackingItem);
        orderReadyMap.set('ready', orderTrackingList);
        // send mog event
        this._restService.sendMogEvent(mogEvent).toPromise();

        // emit here or delegate to next block if related articles to confirm
        if (!orderArticleMap || orderArticleMap.size == 0) {
          orderTrackingList = orderReadyMap.get('ready');
          if (orderTrackingList.length>0) {
            this.onSave.emit(orderReadyMap); // use 'ready' to store parcel on main container
          }
        }
      } 
      
      // confirm related articles 
      let index = 0;
      orderArticleMap.forEach((value: any[], key: string) => {
      let currentOrder = this.relatedOrderList.find(element => element.businessKey == key);

        // get returnTrackingNumber
        this.tracking = null;
        this._storageService.getTrackingsByBusinessKey(currentOrder.businessKey)
        .subscribe(data => {
            // split per space and select 1st one
            let array: string[] = data.split(" ");
            if (array && array.length > 0) {
              this.tracking = array[0];
            }
          
            if (this.tracking) {
              // mog event erstellen (mark selected articles for return)
              let mogEvent = {
                mogid: currentOrder.mogid,
                eventType: 'RETURN',
                returnItems: []
              }
              let returnTrackingNumber = {
                code: this.tracking
              }
              for (let article of value) {
                let returnItem = {
                  reference: article.articleReference,
                  quantity: article.numberOfItems,
                  returnTrackingNumbers: []
                }
                returnItem.returnTrackingNumbers.push(returnTrackingNumber);
                mogEvent.returnItems.push(returnItem);
              }
              // here add order to orderReadyMap (in orderList)
              orderTrackingList = orderReadyMap.get('ready');
              let orderRelItem = currentOrder;
              let trackingRelItem = this.tracking;
              let orderTrackingItemRel = {
                tracking: trackingRelItem,
                order: orderRelItem
              }
              orderTrackingList.push(orderTrackingItemRel);
              orderReadyMap.set('ready', orderTrackingList);

              this._restService.sendMogEvent(mogEvent).toPromise();

              if (index == (orderArticleMap.size - 1)) {
                orderTrackingList = orderReadyMap.get('ready');
                if (orderTrackingList.length>0) {
                  this.onSave.emit(orderReadyMap); // use 'ready' to store parcel on main container
                }  
              }
              index ++;   
            }
          }
        );  
        
      });
      
    } else {
      this._dialogService.openAlert({message: 'There are no articles selected for return!'});
    }
  }

  cancel() {
    this.returnArticles.clear();
    this.onCancel.emit(this.articles);
  }

  async load(): Promise<void> {
    try {
      this._loadingService.register(this.orderBusinessKey);
      this.articles = await this._restService.getArticles(this.orderBusinessKey, this.projectId).toPromise()

      let articleList : any[] = [];
      this.articles.forEach(article => {articleList.push(article.businessKey)});
      let newMap = await this._restService.getArticlesState(articleList).toPromise(); 
      
      this.stateMap.clear();
      for (var value in newMap) {  
        this.stateMap.set(value,newMap[value])  
        this.hasReturned = this.clearedStatus != 'missing_online_return' || newMap[value] !='NO_TARIFFED'; 
      }  

      // load related articles information if necessary
      try {
        if (this.relatedArticleList && this.relatedArticleList.length > 0) {
          let articleList : any[] = [];
          this.relatedArticleList.forEach(articleItem => {articleList.push(articleItem.businessKey)});
          let newMap = await this._restService.getArticlesState(articleList).toPromise(); 
    
          for (var value in newMap) {  
            this.stateMap.set(value,newMap[value])  
          }  
        }
      } catch (error) {
        this._dialogService.openAlert({ message: 'could not load articles for a related order '});
      }

    } catch (error) {
      this._dialogService.openAlert({ message: 'could not load articles for order ' + this.orderBusinessKey });
    } finally {
      this._loadingService.resolve(this.orderBusinessKey);
    }
  }

  selectReturn(article: any) {
    if (this.returnArticles.has(article.businessKey)) {
      this.returnArticles.delete(article.businessKey);
    } else {
      this.returnArticles.add(article.businessKey);
    }
  }

  inReturnList(article: any) {
    return this.returnArticles.has(article.businessKey);
  }

  async forcedReturn(): Promise<void> {
    let storage = {
        businessKey: this.orderBusinessKey,
        containerName: null,
        itemCount: 1,
        projectId:this.projectId,
        reference: this.articles[0].hawb,
        workflowStatus: "ECOMM_RETURN"
      }
    this._loadingService.register(this.orderBusinessKey);
    let response = await this._storageService.updateStorageByBusinesskey(storage, 'UPDATE_WAREHOUSEITEM_STATE', this.parcelCode).toPromise();
    this._loadingService.resolve(this.orderBusinessKey);
    if (response.status == 200){
        this._gasComponent.goBack();  
        this._gasComponent.loadValue(this.scannedSaveValue);    
    }
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/gas/gasArticles/gasarticles.component.ts